// extracted by mini-css-extract-plugin
export default {"container":"BaseLayout-module--container--uCnjF","item":"BaseLayout-module--item--6VBJd"};